export default __webpack_public_path__ + "static/media/error-dark.9fb69437.svg";